<ng-template #contentTemplate>
	<ng-content></ng-content>
</ng-template>

<ng-template #titleSubtitleTagsTemplate>
	@if (title(); as title) {
	<div>
		<div libFlexRow [libFlexRowGap]="'16px'">
			<div libFlexColumn>
				<div libLineClamp [clampLines]="2">
					<h2>{{ title }}</h2>
				</div>
			</div>
			@if (isEditableTitle()) {
			<div libFlexColumn>
				<lib-button
					[tooltip]="'Edit title'"
					[icon]="'edit'"
					[iconOnly]="true"
					(click)="openEditTitle()"
				></lib-button>
			</div>
			}
		</div>
	</div>
	} @if (subtitle(); as subtitle) {
	<div libText3 libLineClamp [clampLines]="1" class="push-top-xs">
		{{ subtitle }}
	</div>
	}
</ng-template>

<div
	class="ui-card layout-large-avatar"
	[class.design-default]="cardDesign() === 'default'"
	[class.design-clean]="cardDesign() === 'clean'"
	[class.design-selection]="cardDesign() === 'selection'"
	[class.design-primary-light]="cardDesign() === 'primaryLight'"
	[class.isInDialog]="isInDialog()"
	[class.removePadding]="true"
	[class.mobile]="isMobileView()"
>
	<ng-container
		>@if (isMobileView()) {
		<div class="mobile-content-padding">
			<ng-template [ngTemplateOutlet]="titleSubtitleTagsTemplate"></ng-template>
		</div>
		<div [libFlexRow]="false" [libFlexRowGap]="'0px'" [libFlexRowAlign]="'start'">
			<div libFlexColumn [libFlexSize]="'170px'">
				<div class="ui-layout-avatar-container">
					<lib-image
						[alt]="'Card avatar'"
						class="w-large-avatar"
						[priority]="imagePriority()"
						[avatarName]="avatarName()"
						[isResponsive]="false"
						[isRound]="false"
						[radiusType]="showNgContent() ? 'right' : 'bottomLeftAndTopRight'"
						[image]="avatar()"
						[imageSize]="'250px'"
						[maxWidth]="170"
						[maxHeight]="170"
					></lib-image>
					<div class="ui-layout-avatar-button" (click)="handleAvatarClick()">
						<lib-icon [type]="'upload'" [color]="'onImage'"></lib-icon>
					</div>
				</div>
			</div>
			<div libFlexColumn libFlexFill>
				@if (calculatedTags(); as tags) {
				<div class="pad-left pad-right pad-bottom">
					<lib-tag-list [tags]="tags" [mode]="'stacked'"></lib-tag-list>
				</div>
				}
			</div>
		</div>
		@if (showNgContent()) {
		<div class="mobile-content-padding">
			<ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
		</div>
		} } @else {
		<div libFlexRow [libFlexRowAlign]="'stretch'" [libFlexRowGap]="'0px'">
			<div libFlexColumn>
				<div class="ui-layout-avatar-container">
					<lib-image
						[alt]="'Card avatar'"
						class="w-large-avatar"
						[priority]="imagePriority()"
						[avatarName]="avatarName()"
						[isResponsive]="false"
						[isRound]="false"
						[radiusType]="'left'"
						[image]="avatar()"
						[imageSize]="'250px'"
						[maxWidth]="250"
						[maxHeight]="250"
					></lib-image>
					@if (isEditableAvatar()) {
					<div class="ui-layout-avatar-button" (click)="handleAvatarClick()">
						<lib-icon [type]="'upload'" [color]="'onImage'"></lib-icon>
					</div>
					}
				</div>
			</div>

			<div libFlexColumn libFlexFill>
				<div class="w-large-avatar-content">
					<div libFlexRow [libFlexRowAlign]="'start'" [libFlexRowGap]="'16px'">
						<div libFlexColumn libFlexFill>
							<ng-template [ngTemplateOutlet]="titleSubtitleTagsTemplate"></ng-template>

							@if (calculatedTags(); as tags) {
							<div class="push-top">
								<lib-tag-list
									[tags]="tags"
									[mode]="isMobileOrTabletView() ? 'stacked' : 'default'"
								></lib-tag-list>
							</div>
							}
						</div>
						@if (buttons(); as buttons) { @if (buttons && buttons.length) {
						<div libFlexColumn>
							<lib-button-list
								[extendListThreshold]="buttonsExtendedListThreshold()"
								[buttons]="buttons"
								[mode]="buttonsMode()"
								[moreIcon]="buttonsMoreIcon()"
							></lib-button-list>
						</div>
						} }
					</div>
					@if (showNgContent()) {
					<div class="push-top">
						<ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
					</div>
					}
				</div>
			</div>
		</div>
		}
	</ng-container>
</div>
